import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer

let service = new services();

export default {
    name: 'CNwallet',
    data () {
        return {
            user: {},
            payment_details:{},
            wallet_charges:{},
            wallet_transaction: {},
            wallet_transactions: {},
            current_wallet_balance: 0,
            bank:{},
            to_pay_out: 0,
            amount_paid: '',
            wallet_payment_message:'',
            wallet_payment_error_message:'',
            min_wallet_topup_amount: 100,
            max_wallet_topup_amount:10000,
            wallet_payment_calculated:false,
            loading:true,
            disable_btn:false,
        }
    },
    components: {
        'component-header': SecondHeader,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel() {
            this.panelFlag = true
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            return currency;
        },
        closeModal(modal){
            $(modal).modal("hide");
            //some refresh
            this.wallet_transaction = {};
            this.wallet_payment_calculated= false;
            this.wallet_payment_message = '';
            this.wallet_payment_error_message='';
            
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        setWalletTransaction(txn){
            this.wallet_transaction = txn;
        },

        //get wallet processing charges
        getWalletProcessingCharges() {
            service.getWalletProcessingChargesRF(this).then(data => { //Uing RF for now
                this.wallet_charges = data.body.data;
                this.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount; //already set min balance
                this.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount; //already set min balance
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getWalletTransactions() {
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getWalletTransactions(this,user_id).then(data => {
                if(data.body.status == 200) {
                    this.current_wallet_balance = data.body.data_current_wallet_balance;
                    localStorage.setItem("cityneeds_wb", this.current_wallet_balance);
                }
                this.wallet_transactions = data.body.data;
                this.loading = false;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        
        prepareWalletPayment(){
            if(this.wallet_transaction.topay_amt == null){
                toastr.error('Amount is empty', 'Warning!');
            }else{
                this.wallet_transaction.topay_amt = parseFloat(this.wallet_transaction.topay_amt); //casting
            
                if(this.wallet_transaction.topay_amt > this.max_wallet_topup_amount){
                    this.wallet_payment_error_message = 'Maximum Topup amount exceeded';
                    toastr.error('Maximum Topup amount exceeded', 'Warning!');
                }
                else if(this.wallet_transaction.topay_amt < this.min_wallet_topup_amount){
                    this.wallet_payment_error_message = 'Minimum Topup amount is 100NGN';
                    toastr.error('Minimum Topup amount is 100', 'Warning!');
                }
                else{
                    //check for matching processing fee
                    this.wallet_charges.forEach(function(element) {
                        if((this.wallet_transaction.topay_amt >= element.wallet_charge_min) && (this.wallet_transaction.topay_amt <= element.wallet_charge_max)){
                            this.wallet_transaction.processing_fee = element.wallet_charge_charge;
                        }
                    }, this);
                    this.wallet_payment_calculated = true;
                }
            }
        },

        makePayment(){
            this.disable_btn = true;
           let user_id = localStorage.getItem("cityneeds_token_key");
           var payload = {
               "user": user_id,
               "service": 2, //wallet top-up
            }
           service.setUserPaymentDetails(this,payload).then(data => {
                this.payment_details = data.body.data;
                //then process payment
                this.processPayment();
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        processPaymentXX(){
            let self = this;
            let txref = self.payment_details.payer_txn_ref;
            let   tx_amount = (self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee);
            let txn_payload={
                "txn_ref": txref,
                "pay": self.user.user_id,
                "txn_amount": self.wallet_transaction.topay_amt,
                "processing_fee": self.wallet_transaction.processing_fee,
                "topup_by_admin": 0,
                "total_amount": tx_amount
            };
            //post payment
            service.postWalletTopup(self,txn_payload).then(response => {
                //success message
                self.disable_btn = false;
                self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                self.loading = true;
                setTimeout(function (){

                    self.closeModal('#topup');
                  
                  }, 4000);
                
                //this get wallet transaction
                self.getWalletTransactions();
                
            }).catch((err) => {
                //console.log(err)
            })
        },

        processPayment() {
            let self = this;
            var x = getpaidSetup({
               // PBFPubKey: "FLWPUBK-7bfea41df783f28ad7c71d9925a1bc57-X", //api public key//live
                PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X", //test
                customer_email: self.payment_details.payer_email, // "mail@gmail.com"
                amount: (self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee),
                customer_phone: self.payment_details.payer_phone, //"234099940409"
                currency: "NGN",
                payment_method: "both",
                txref: "CNwallet-"+self.payment_details.payer_txn_ref,
                meta: [{
                    metaname: "CNwallet",
                    metavalue: self.payment_details.payer_name
                }],
                onclose: function() {},
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.processing = true;
                        
                        // redirect to a success page
                       // console.log("good to go!"+txref)

                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                        //     // console.log(response); // 42
                        //     // console.log(response.body.data.status); // 42
                        //     if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                        //         //check if the amount is same as amount you wanted to charge just to be very sure
                        //         self.payment_message = "Payment processed successfully, check your email for your receipts."
                                
                        //         if (response.body.data.amount === tx_amount) {
                        //             //enter into db
                                    

                                    let txn_payload={
                                        "txn_ref": txref,
                                        "pay": self.user.user_id,
                                        "txn_amount": self.wallet_transaction.topay_amt,
                                        "processing_fee": self.wallet_transaction.processing_fee,
                                        "topup_by_admin": 0,
                                        "total_amount": tx_amount
                                    };
                                    //post payment
                                    service.postWalletTopup(self,txn_payload).then(response => {
                                        //success message
                                        self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                                        self.loading = true;
                                        self.disable_btn = false;
                                        setTimeout(function (){
                        
                                            self.closeModal('#topup');
                                          
                                          }, 4000);
                                        
                                        //this get wallet transaction
                                        self.getWalletTransactions();
                                        
                                    }).catch((err) => {
                                        //console.log(err)
                                    })
                            //     }
                            // }
                           
                            
                        // }).catch((err) => {
                        //     //console.log(34545)
                        //    // console.log(err)
                        // })
                        //...//....server validation
                    } else {
                        // redirect to a failure page.
                        //console.log("bad to go!"+txref)
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
    
                    x.close(); // use this to close the modal immediately after payment.
                }
            });
        },
 
        
    },
    created: function(){
        this.preset();
        this.getWalletProcessingCharges();
        this.getWalletTransactions();
        
    }
}


// WEBPACK FOOTER //
// ./src/components/Wallet/script.js